import { remove } from 'remove-accents'
import { myConsoleLog, ENDPOINT_ALBUM, ENDPOINT_AUTEUR, ENDPOINT_SERIE, ENDPOINT_GRAB, COUVERTURES_DIRECTORY, DEDICACES_DIRECTORY, ENDPOINT_COUVERTURE, ENDPOINT_DEDICACE, ENDPOINT_TOMEFINDER } from './constantes'
import { authFetch } from './authFetch'

const JSON_HEADERS = { 'Content-type': 'application/json' };

// Helper centralisé pour toutes les écritures API (DRY)
async function apiWrite(tag, url, method, body, extraOptions = {}) {
    const { headers: extraHeaders, ...rest } = extraOptions;
    try {
        const res = await authFetch(url, {
            method,
            headers: { ...JSON_HEADERS, ...extraHeaders },
            ...(body !== undefined && { body: JSON.stringify(body) }),
            ...rest,
        });
        const data = await res.json();
        myConsoleLog(tag, data);
        return data;
    } catch (error) {
        console.warn(tag, error);
    }
}

export const writeIgnorelist = async (item) => {
    if(item?._id) {
        return apiWrite('ENDPOINT_TOMEFINDER', ENDPOINT_TOMEFINDER + item._id, 'PATCH', item);
    }
}

function formatSerieAndTome(album, dedicace = false) {
    const serieWithoutAccent = remove(album.serie)
    const serieLowercase = serieWithoutAccent.toLowerCase()
    const isTomePresent = album.tome ? album.tome?.toLowerCase() : ''
    const albumLowercase = `${serieLowercase}_${isTomePresent}.jpg`
    return dedicace ? `${albumLowercase}` : `${serieLowercase}/${albumLowercase}`
}

export const formatCouverturePath = (album) => {
    return `${COUVERTURES_DIRECTORY}${formatSerieAndTome(album)}`
}

export const formatDedicacePath = (album,) => {
    return `${DEDICACES_DIRECTORY}${formatSerieAndTome(album, true)}`
}

export function handleAnchor (hash) {
    setTimeout(() => {
        const el = document.getElementById(hash)
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            window.history.replaceState(null, '', `#${hash}`)
        }
    }, 100)
}

// @DOC-BYROD shallowEqual
export function shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }
    return true;
}

export async function updateBigAlbum(id, body) {
    return apiWrite('UPDATE_BIGALBUM', ENDPOINT_ALBUM + id, 'PATCH', body);
};

export async function deleteAlbum(id, body) {
    return apiWrite('DELETE_BIGALBUM', ENDPOINT_ALBUM + id, 'DELETE', body);
};

export async function createAlbumInBedetheque(jsonBody) {
    return apiWrite('CREATE_BIGALBUM', ENDPOINT_ALBUM, 'POST', jsonBody, {
        cache: 'no-store',
        headers: { 'cache-control': 'no-cache', 'pragma': 'no-cache' },
    });
};

export async function updateSerie(id, body) {
    return apiWrite('UPDATE_SERIE', ENDPOINT_SERIE + id, 'PATCH', body);
};

export async function updateAuteur(id, body) {
    return apiWrite('UPDATE_AUTEUR', ENDPOINT_AUTEUR + id, 'PATCH', body);
};

// Édite les auteurs d'un album (ajout / retrait / remplacement). Le corps contient
// des références mixtes {_id} | {nom} ; la résolution/création se fait côté serveur.
export async function updateAlbumAuteurs(id, body) {
    return apiWrite('UPDATE_ALBUM_AUTEURS', ENDPOINT_ALBUM + id + '/auteurs', 'PATCH', body);
};

export async function grabAlbum(url) {
    return apiWrite('GRAB_BIGALBUM', ENDPOINT_GRAB, 'POST', { url });
}

export async function updateCouverture(id, url) {
    return apiWrite('UPDATE_COUVERTURE', ENDPOINT_COUVERTURE + id, 'POST', { newCouvUrl: url });
}

// Upload d'une dédicace : envoi d'un vrai fichier (multipart/form-data). On n'utilise pas
// apiWrite (qui force le JSON) — le navigateur pose lui-même le bon Content-Type + boundary.
export async function updateDedicace(id, file) {
    const formData = new FormData();
    formData.append('dedicace', file);
    try {
        const res = await authFetch(ENDPOINT_DEDICACE + id, { method: 'POST', body: formData });
        const data = await res.json();
        myConsoleLog('UPDATE_DEDICACE', data);
        return data;
    } catch (error) {
        console.warn('UPDATE_DEDICACE', error);
    }
}
